export default __webpack_public_path__ + "static/media/logoE4L.2142ad4d.png";